import React from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import { FaCode, FaUsers, FaTools, FaRocket } from 'react-icons/fa';
import './Services.css';

const Services = () => {
  const navigate = useNavigate();
  const services = [
    {
      id: 1,
      icon: <FaCode />,
      title: "Desenvolvimento de Sistemas",
      description: "Soluções sob medida para digitalizar, automatizar e escalar seu negócio com tecnologia. Do zero ao sistema completo.",
      features: ["Sistemas Web", "Aplicações Desktop", "APIs e Integrações", "Aplicativos"],
      href: "/servicos/desenvolvimento-sistemas"
    },
    {
      id: 2,
      icon: <FaRocket />,
      title: "Criação de Sites",
      description: "Sites que transmitem confiança, funcionam em qualquer dispositivo e geram resultados reais para sua empresa.",
      features: ["Design Responsivos", "E-commerce de Alta Performance", "Landing Pages Estratégicas", "SEO para ranqueamento no Google"],
      href: "/servicos/criacao-sites"
    },
    {
      id: 3,
      icon: <FaTools />,
      title: "Prototipação",
      description: "Valide suas ideias com protótipos interativos e entenda como o sistema vai funcionar antes de investir pesado no desenvolvimento.",
      features: ["Wireframes de Navegação", "Protótipos com Interações", "Testes de Usabilidade com Usuários", "Validação com Stakeholders"],
      href: "/servicos/prototipacao"
    },
    {
      id: 4,
      icon: <FaUsers />,
      title: "Consultorias, Palestras, Workshops",
      description: "Compartilhamos experiência prática para transformar times, ideias e projetos. Conte com nosso apoio para evoluir com conhecimento real.",
      features: ["Consultoria em Tecnologia e Inovação", "Palestras", "Mini Cursos Técnicos", "Workshops Práticos"],
      href: "/servicos/consultorias"
    }
  ];

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };

  const cardVariants = {
    hidden: { y: 50, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: {
        duration: 0.6
      }
    }
  };

  const handleServiceClick = (service) => {
    navigate(service.href);
  };

  return (
    <section id="servicos" className="section services-section">
      <div className="container">
        <motion.div
          className="section-header"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          <h2 className="section-title">Nossos Serviços</h2>
          <p className="section-subtitle">Soluções completas para impulsionar seu negócio</p>
        </motion.div>

        <motion.div
          className="services-grid"
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
        >
          {services.map((service) => (
            <motion.div
              key={service.id}
              className="service-card"
              variants={cardVariants}
              whileHover={{ y: -10 }}
              onClick={() => handleServiceClick(service)}
            >
              <div className="service-icon">
                {service.icon}
              </div>
              <h3 className="service-title">{service.title}</h3>
              <p className="service-description">{service.description}</p>
              <ul className="service-features">
                {service.features.map((feature, index) => (
                  <li key={index}>{feature}</li>
                ))}
              </ul>
              <div className="service-cta">
                <button 
                  className="btn btn-primary service-btn"
                  onClick={() => handleServiceClick(service)}
                >
                  Ver mais
                </button>
              </div>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default Services; 